module.exports = __webpack_public_path__ + "static/18-51741fdc16562dce6e7f54694d33de3a.png";